/** @prettier */
import { replace } from 'react-router-redux';

import { getSignUpFlag } from '@xanadu/ui-shared/components/SignUp/utils';
import { dispatch as gtmDispatch, loginTypes } from '@xanadu/ui-shared/interfaces/googleTagManager';
import {
  userLogin as gtmUserLogin,
  userRegistration as gtmUserRegistration,
} from '@xanadu/ui-shared/interfaces/googleTagManager/actions';
import { track, identify as woopraIdentify } from '@xanadu/ui-shared/interfaces/woopra';
import { setLocalStorageItem } from '@xanadu/ui-shared/modules/dataLayer/actions';
import { dismissMarketingConsentReminder } from '@xanadu/ui-shared/modules/user/actions';
import { REGISTRATION_SUCCESS } from '@xanadu/ui-shared/modules/userRegistration/actions';
import { initialiseUser } from '@xanadu/ui-shared/modules/userSession/actions';

import { all, fork, put, take } from 'redux-saga/effects';

function* watchUserRegistration() {
  while (true) {
    const { payload: accountData } = yield take(REGISTRATION_SUCCESS);

    yield put(initialiseUser(accountData));

    localStorage.setItem('mb-currency', accountData.currency);
    localStorage.setItem('mb-oddsType', accountData['odds-type-id']);

    yield put(
      setLocalStorageItem({
        key: 'mb-previous-user-login',
        value: {
          accountID: accountData.id,
          userID: accountData['user-id'],
        },
      })
    );

    // Cookie needed for Marketing;
    const userId = accountData.id;
    const legacyUserId = accountData['user-id'];
    gtmDispatch(gtmUserRegistration(accountData));
    gtmDispatch(gtmUserLogin({ loginType: loginTypes.loginButton, data: accountData }));

    woopraIdentify({
      accountId: userId,
    });

    gtmDispatch({
      payload: {
        user_id: userId,
      },
    });

    track('Registration', 'Registration Completed', {
      accountId: userId,
      userId: legacyUserId,
      description: userId,
      trials: getSignUpFlag('mb-user-reg-trials'),
      visits: getSignUpFlag('mb-user-returning-times'),
    });

    if (!accountData['marketing-consent']) {
      yield put(dismissMarketingConsentReminder());
    }

    if (window.location.pathname.includes('/promo/')) {
      yield put(replace('/'));
    }
  }
}

export default function* root() {
  yield all([fork(watchUserRegistration)]);
}
